import React, { useEffect, useRef, useState } from 'react';
import { featuredProducts } from '../../data/products';
import ProductCard from '../ProductCard/ProductCard';
import ProductPage from '../ProductPage/ProductPage';
import './FeaturedProducts.css';

const FeaturedProducts = () => {
  const sectionRef = useRef(null);
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const cards = sectionRef.current?.querySelectorAll('.product-card');
    cards?.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  const handleProductClick = (productId) => {
    setSelectedProduct(productId);
  };

  const handleCloseProduct = () => {
    setSelectedProduct(null);
  };

  return (
    <section id="featured" className="featured-products section-padding" ref={sectionRef}>
      <div className="container">
        <div className="section-header text-center">
          <h2>Featured Collection</h2>
          <p className="section-subtitle">
            Discover our most celebrated pieces, each representing<br />
            the pinnacle of our artisanal heritage
          </p>
        </div>
        
        <div className="featured-grid">
          {featuredProducts.map((product, index) => (
            <ProductCard 
              key={product.id}
              product={product} 
              featured={true} 
              onProductClick={handleProductClick}
              animationDelay={`${index * 0.2}s`}
            />
          ))}
        </div>
      </div>

      {selectedProduct && (
        <ProductPage 
          productId={selectedProduct} 
          onClose={handleCloseProduct}
        />
      )}
    </section>
  );
};

export default FeaturedProducts;